import React from "react";

const Sabong = () => {
  return <div>Sabong</div>;
};

export default Sabong;
